__turbopack_context__.v({
  "buttons": "-z15mW_buttons",
  "calculateButton": "-z15mW_calculateButton",
  "content": "-z15mW_content",
  "list": "-z15mW_list",
  "mktuClassesSidebar": "-z15mW_mktuClassesSidebar",
  "registrateButton": "-z15mW_registrateButton",
  "searchButton": "-z15mW_searchButton",
});
